import { ComponentProps } from "react";

import { SkeletonLoader } from "@whoosh/design-system/src/components/display";
import {
  Box,
  HStack,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

const skeletonRows = Array.from({ length: 8 }, (_, index) => index);

type PlayersListSkeletonProps = {
  px?: ComponentProps<typeof VStack>["px"];
};

export const PlayersListSkeleton = ({ px }: PlayersListSkeletonProps) => {
  return (
    <VStack gap={2} px={px} py={2} testID="players-list-skeleton">
      {skeletonRows.map((index) => (
        <HStack
          key={`players-list-skeleton-row-${index}`}
          alignItems="center"
          justifyContent="space-between"
          py={2}
        >
          <HStack alignItems="center" gap={2}>
            <SkeletonLoader width={40} height={40} borderRadius="2" />
            <SkeletonLoader width={140} height={16} borderRadius="0.5" />
          </HStack>
          <Box pr={1}>
            <SkeletonLoader width={16} height={16} borderRadius="0.5" />
          </Box>
        </HStack>
      ))}
    </VStack>
  );
};
